// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.inline-tree-container .vue-treeselect__menu-container,\n.inline-tree-container .vue-treeselect__menu{\n    position: static;\n}\n", ""]);
// Exports
module.exports = exports;
